module.exports = __webpack_public_path__ + "static/media/hero-girl.d6c7899d.webp";